import * as React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/shadcn/components/ui/select';
import { useShopLocationsContext } from '../WorkOrdersPage/Contexts/ShopLocationsContext';
import { ShopLocationContextFragment } from '../WorkOrdersPage/Contexts/__generated__/ShopLocationsContext.generated';

export interface IShopLocationPickerProps {
  onLocationPicked: (shopLocation: ShopLocationContextFragment) => void;
  selectedLocation: ShopLocationContextFragment | undefined;
}

export const ShopLocationPicker: React.FunctionComponent<
  IShopLocationPickerProps
> = props => {
  const { shopLocations, isLoadingLocations } = useShopLocationsContext();
  return (
    <>
      <Select
        defaultValue={props.selectedLocation?.id}
        value={props.selectedLocation?.id}
        onValueChange={newLocationId => {
          const newLocation = shopLocations?.find(
            location => location.id == newLocationId
          );
          if (newLocation) {
            props.onLocationPicked(newLocation);
          }
        }}
      >
        <SelectTrigger className='flex'>
          <SelectValue
            placeholder={
              isLoadingLocations ? 'Loading locations' : 'Select a location'
            }
            className='h-8'
          />
        </SelectTrigger>
        <SelectContent>
          {shopLocations?.map(shopLocation => (
            <SelectItem key={shopLocation.id} value={shopLocation.id}>
              {shopLocation.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  );
};
